export class PostGetProviderSearchRequest {
    nameOrSpecialty?: string;
    providerName?: string;
    cityOrZip?: string;
    languages?: string; // Comma-separated list
    specialties?: string; // Comma-separated list
    affiliations?: string; // Comma-separated list
    gender?: string;
    onlineScheduling?: boolean;
    quickSearch? : string; // e.g., "PrimaryCare", "OBGYN", etc.
    
    distanceInMiles?: number = 15;
    longitude?: number;
    latitude?: number;

    usePaging? : boolean = false;
    pageSize?: number = 10;
    pageIndex?: number = 0;
}

export class PostGetLocationSearchRequest {
    nameOrServiceOrType?: string;
    locationName?: string;
    cityOrZip?: string;
    languages?: string; // Comma-separated list
    services?: string; // Comma-separated list
    types?: string; // Comma-separated list
    gender?: string;
    onlineScheduling?: boolean;
    
    distanceInMiles?: number = 15;
    longitude?: number;
    latitude?: number;

    usePaging? : boolean = false;
    pageSize?: number = 10;
    pageIndex?: number = 0;
}